// extracted by mini-css-extract-plugin
export default {"wrapper":"o3-z","play":"p3-z"};